import Link from 'next/link'
import { generateBlogPostLink } from '../helpers/utils'
import { isObject } from 'lodash'

function BlogTitleBlock({ post, size = 'text-lg', isSidePosts = true }) {
    return (
        <h2>
            <Link href={generateBlogPostLink(post)}>
                <a
                    className={`block mt-2 ${size} ${
                        !isSidePosts && 'font-normal'
                    } text-blog-black hover:text-olh`}>
                    {isObject(post.title)
                        ? post.title.rendered
                        : post.post_title}
                </a>
            </Link>
        </h2>
    )
}

export default BlogTitleBlock
